"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.OauthRegistrationUserAccessType = exports.OauthRegistrationTargetAudience = exports.OauthRegistrationAppType = exports.TokenExchangeMethodType = void 0;
var TokenExchangeMethodType;
(function (TokenExchangeMethodType) {
    TokenExchangeMethodType["BasicAuthorizationHeader"] = "BasicAuthorizationHeader";
    TokenExchangeMethodType["PostRequestBody"] = "PostRequestBody";
})(TokenExchangeMethodType || (exports.TokenExchangeMethodType = TokenExchangeMethodType = {}));
var OauthRegistrationAppType;
(function (OauthRegistrationAppType) {
    OauthRegistrationAppType["SpecificApp"] = "SpecificApp";
    OauthRegistrationAppType["AnyApp"] = "AnyApp";
})(OauthRegistrationAppType || (exports.OauthRegistrationAppType = OauthRegistrationAppType = {}));
var OauthRegistrationTargetAudience;
(function (OauthRegistrationTargetAudience) {
    OauthRegistrationTargetAudience["HomeTenant"] = "HomeTenant";
    OauthRegistrationTargetAudience["AnyTenant"] = "AnyTenant";
})(OauthRegistrationTargetAudience || (exports.OauthRegistrationTargetAudience = OauthRegistrationTargetAudience = {}));
var OauthRegistrationUserAccessType;
(function (OauthRegistrationUserAccessType) {
    OauthRegistrationUserAccessType["Read"] = "Read";
    OauthRegistrationUserAccessType["ReadWrite"] = "ReadWrite";
})(OauthRegistrationUserAccessType || (exports.OauthRegistrationUserAccessType = OauthRegistrationUserAccessType = {}));
//# sourceMappingURL=OauthRegistration.js.map